import React from "react"
import { NavBar } from "../../Navbar"
import { LandingSection } from "./LandingSection"
import { ExperienciaSection } from "./ExperienciaSection"
import { ColaboradoresSection } from "./ColaboradoresSection"
import { PostVentaSection } from "./PostVentaSection"
import { PlanesSection } from "./PlanesSection"

export const Servicios = () => {
  const colorText = "#253EAF"
  const classTitle = "servicios"
  return (
    <>
      <NavBar
        colorText={colorText}
        classTitle={classTitle}
      />
      <section id="Servicios" className="servicios-section">
        <LandingSection />
        <ExperienciaSection />
        <ColaboradoresSection />
        <PostVentaSection />
        <PlanesSection />
      </section>
    </>
  )
}
